import { createPrefetchableAsyncUserDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPetitionDetailsPageUserData } from './api';
import type { PetitionDetailsPageUserDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: PetitionDetailsPageUserDataContext,
	Provider: PetitionDetailsPageUserDataContextProvider,
	useContext: usePetitionDetailsPageUserData,
	useAsyncData: usePetitionDetailsPageUserDataFromApi,
	prefetchAsyncData: prefetchPetitionDetailsPageUserDataFromApi,
} = createPrefetchableAsyncUserDataContext({
	name: 'PetitionDetailsPageUserDataContext',
	dataProperty: 'pageUserData',
	getData: getPetitionDetailsPageUserData,
	getUniqueId: (slug, { currentUserId, loginState, decisionMakerHash }) =>
		[slug, currentUserId, loginState, decisionMakerHash].join(','),
	hookDeps: (slug, { currentUserId, loginState, decisionMakerHash }) => [
		slug,
		currentUserId,
		loginState,
		decisionMakerHash,
	],
	errorHandler: pageDataErrorHandler<PetitionDetailsPageUserDataErrorCode>(),
});
